module.exports = __webpack_public_path__ + "img/12.4d3a4306.png";